import { motion } from "framer-motion";
import { MaskLine } from "./Reveal";
import { STUDIO } from "../../data";

export const Hero = () => {
  const go = (id) => {
    const el = document.getElementById(id);
    if (window.__lenis) window.__lenis.scrollTo(el, { offset: -20 });
    else el?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="top"
      className="relative min-h-[100svh] flex flex-col items-center justify-center text-center px-5 pt-28 pb-16 overflow-hidden"
    >
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3, duration: 1 }}
        className="text-xs uppercase tracking-[0.32em] text-[#7A766C] mb-10 sm:mb-12"
        data-testid="hero-overline"
      >
        {STUDIO.location}
      </motion.p>

      <motion.div
        initial={{ opacity: 0, y: 30, scale: 0.96 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 1.4, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
        className="rounded-[2.5rem] overflow-hidden border border-[#E4DBCA] shadow-[0_30px_80px_-45px_rgba(62,59,50,0.5)]"
      >
        <img
          src="/logo.png"
          alt="Sové Skin Studio"
          className="w-[min(360px,74vw)] h-auto block select-none"
          data-testid="hero-logo"
          draggable="false"
        />
      </motion.div>

      <h1 className="mt-2 font-serif font-light text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tight text-[#1A1A18]">
        <MaskLine delay={0.7}>Skin, kept</MaskLine>
        <MaskLine delay={0.82}>
          <span className="italic text-[#3E3B32]">quietly</span> radiant.
        </MaskLine>
      </h1>

      <motion.p
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1.05, duration: 1, ease: [0.22, 1, 0.36, 1] }}
        className="mt-8 max-w-md text-[#4A4843] leading-relaxed"
      >
        A home-based skin, brow & lash studio in Boronia — tailored treatments and a
        slower, kinder kind of beauty.
      </motion.p>

      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1.18, duration: 1, ease: [0.22, 1, 0.36, 1] }}
        className="mt-10 flex flex-wrap items-center justify-center gap-4"
      >
        <button
          onClick={() => go("contact")}
          data-testid="hero-book-cta"
          className="rounded-full bg-[#3E3B32] px-8 py-3.5 text-sm text-[#F8F6F0] hover:bg-[#1A1A18] transition-colors duration-300"
        >
          Request an appointment
        </button>
        <button
          onClick={() => go("services")}
          data-testid="hero-services-cta"
          className="group text-sm tracking-wide text-[#1A1A18] flex items-center gap-2"
        >
          View the menu
          <span className="h-px w-8 bg-[#1A1A18] transition-all duration-300 group-hover:w-12" />
        </button>
      </motion.div>
    </section>
  );
};
